import { SVGProps } from 'react';

export const ClientEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69213 7.82871L5.61536 6.45517C5.5669 6.34256 5.53875 6.21932 5.53875 6.08871L5.53829 6.08825V5.62671H0.922902C0.833363 5.62671 0.74844 5.64379 0.666748 5.66779L3.69213 7.82871Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.42923 7.0115L3.96046 8.77181C3.88015 8.82904 3.786 8.85765 3.69231 8.85765C3.59815 8.85765 3.50446 8.82904 3.42415 8.77181L0.0249231 6.34412C0.00969231 6.41058 0 6.47889 0 6.54996V10.2423C0 10.7513 0.414 11.1653 0.923077 11.1653H6.46154C6.97062 11.1653 7.38462 10.7513 7.38462 10.2423V7.0115H6.42923Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.46161 3.37318C10.1616 3.37318 10.7308 2.80393 10.7308 2.10395C10.7308 1.40397 10.1616 0.834717 9.46161 0.834717C8.76163 0.834717 8.19238 1.40397 8.19238 2.10395C8.19238 2.80393 8.76163 3.37318 9.46161 3.37318Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.46156 3.69043C7.96704 3.69043 6.9231 4.47323 6.9231 5.59428V5.91158H12V5.59428C12 4.47323 10.9561 3.69043 9.46156 3.69043Z"
      fill="currentColor"
    />
  </svg>
);
